export type ClientFollowUp = 'contacted' | 'validated';

export const CLIENT_FOLLOW_UP_OPTIONS: { value: '' | ClientFollowUp; label: string }[] = [
  { value: '', label: '—' },
  { value: 'contacted', label: 'Contacté' },
  { value: 'validated', label: 'Validé' },
];

export const CLIENT_FOLLOW_UP_LABELS: Record<
  ClientFollowUp,
  { label: string; className: string }
> = {
  contacted: { label: 'Contacté', className: 'bg-indigo-100 text-indigo-700' },
  validated: { label: 'Validé', className: 'bg-green-100 text-green-700' },
};

/** Anciens slugs encore possibles en base avant migration / cache. */
const LEGACY_TO_FOLLOW_UP: Record<string, ClientFollowUp | null> = {
  contacted: 'contacted',
  validated: 'validated',
  client_contacted: 'contacted',
  dossier_created: 'validated',
  to_contact: null,
  awaiting_client: null,
};

export function normalizeClientFollowUp(
  raw: string | null | undefined,
): ClientFollowUp | null {
  if (!raw) return null;
  if (raw in LEGACY_TO_FOLLOW_UP) return LEGACY_TO_FOLLOW_UP[raw] ?? null;
  return null;
}

export function isTicketValidated(ticket: {
  client_status: string | null;
  converted_to_dossier_id?: string | null;
}): boolean {
  if (ticket.converted_to_dossier_id) return true;
  return normalizeClientFollowUp(ticket.client_status) === 'validated';
}

export function clientFollowUpDisplay(raw: string | null | undefined): {
  label: string;
  className: string;
} | null {
  const key = normalizeClientFollowUp(raw);
  return key ? CLIENT_FOLLOW_UP_LABELS[key] : null;
}
